'use client';

import { MantineProvider, createTheme } from '@mantine/core';
import { ModalsProvider } from "@mantine/modals";
import { Provider as JotaiProvider } from 'jotai';
import React from 'react';

const theme = createTheme({
  defaultRadius: "0.5rem",
});

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <JotaiProvider>
      <MantineProvider theme={theme}>
        <ModalsProvider>
          {children}
        </ModalsProvider>
      </MantineProvider>
    </JotaiProvider>
  );
}